<div rt="sidebar-search-results">
  <ul role="tablist" class="nav nav-tabs nav-justified">
    <li class="nav-item">
      <a class="nav-link p-3" routerLinkActive="active" rt="list-view" [routerLinkActiveOptions]="{ exact: false }" [routerLink]="searchResultsUrl"
        >List View</a
      >
    </li>
    <li class="nav-item">
      <a class="nav-link p-3" rt="map-view" routerLinkActive="active" [routerLink]="mapUrl" [routerLinkActiveOptions]="{ exact: false }">Map View</a>
    </li>
  </ul>
  <ng-container *ngIf="searchRequest != null">
    <div class="tab-content mt-3">
      <form>
        <div class="form form-group job-location-container" *ngIf="searchRequest.location.location != null">
          <label for="location">Location Radius</label>
          <common-dropdown
            [dropDownItems]="searchRequest.location.radiusOptions"
            [selectedValue]="searchRequest.location.selectedRadius"
            (itemSelected)="filter()"
            customClass="form-control btn-white"
          >
          </common-dropdown>
        </div>

        <!-- Type dropdown -->
        <div class="form-group">
          <h4 for="category ">Category</h4>
          <app-machine-category-media-list
            [categories]="searchRequest.primaryType.primaryTypes"
            [makes]="searchRequest.make.facets"
            [location]="location"
          ></app-machine-category-media-list>
        </div>
        <div
          class="form-group"
          *ngIf="searchRequest.rpoEnabled.facets?.length || searchRequest.buyItNowEnabled.facets?.length || searchRequest.isTopOwner.facets?.length"
        >
          <label for="rpo">Purchase Options</label>
          <app-facet-checkbox-group
            [facetGroup]="searchRequest.isTopOwner.facets"
            [showBorderBottom]="false"
            (checkboxChange)="filter()"
          ></app-facet-checkbox-group>
          <app-facet-checkbox-group
            [facetGroup]="searchRequest.buyItNowEnabled.facets"
            [showBorderBottom]="false"
            (checkboxChange)="buyItNowOrRtoChange()"
          ></app-facet-checkbox-group>
          <app-facet-checkbox-group [facetGroup]="searchRequest.rpoEnabled.facets" (checkboxChange)="buyItNowOrRtoChange()"></app-facet-checkbox-group>
        </div>
        <!--  only show if primary type is selected and there is more then 1 type definition. the reason for the length check of 2 is because we have an 'All' facet. this does not apply any more. only if its a radio facet. -->
        <div class="form-group" *ngIf="searchRequest.primaryType.facets.length === 1 && !loadingPrimaryTypes && searchRequest.typeDefinition.facets.length > 1">
          <app-facet-checkbox-group [facetGroup]="searchRequest.typeDefinition.facets" facetName="Type" (checkboxChange)="filterTypeDefinition()">
          </app-facet-checkbox-group>
        </div>

        <!-- Model -->
        <app-facet-checkbox-group [facetGroup]="searchRequest.model.facets" facetName="Model" (checkboxChange)="filterModel()"> </app-facet-checkbox-group>

        <!-- Start of attachments -->
        <div
          class="form-group"
          data-type="checkbox"
          *ngIf="searchRequest.attachment.catalogs.facets.length > 1 || searchRequest.attachment.catalogs.selected || searchRequest.attachment.specs.selected"
        >
          <app-facet-checkbox-group
            [facetGroup]="searchRequest.attachment.catalogs.facets"
            [facetSubGroup]="searchRequest.attachment.specs.facets"
            facetName="Attachment"
            (checkboxChange)="filter()"
            [useLabelWhenOne]="true"
            [useSingleState]="true"
          >
          </app-facet-checkbox-group>
        </div>

        <!-- Hours -->
        <app-facet-range-slider
          [facetRange]="searchRequest.hours.slider"
          facetName="Hours"
          useCommas="true"
          (rangeSliderChange)="filter()"
        ></app-facet-range-slider>

        <!-- Weight -->
        <app-facet-range-slider
          [facetRange]="searchRequest.weight.slider"
          facetName="Weight"
          useCommas="true"
          (rangeSliderChange)="filter()"
        ></app-facet-range-slider>

        <!-- Horse Power -->
        <app-facet-range-slider
          [facetRange]="searchRequest.enginePower.slider"
          facetName="Horsepower"
          [useCommas]="true"
          (rangeSliderChange)="filter()"
        ></app-facet-range-slider>

        <!-- Year -->
        <app-facet-range-slider [facetRange]="searchRequest.year.slider" facetName="Year" (rangeSliderChange)="filter()"></app-facet-range-slider>
      </form>
    </div>
  </ng-container>
</div>
